"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2776%3A732))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.016Z
 */
export const Save = createSVGIcon(
  <path
    d="M18.8571 23.1429L12 16.2857L5.14282 23.1429V2.57146C5.14282 2.11681 5.32343 1.68077 5.64492 1.35928C5.96642 1.03779 6.40245 0.857178 6.85711 0.857178H17.1428C17.5975 0.857178 18.0335 1.03779 18.355 1.35928C18.6765 1.68077 18.8571 2.11681 18.8571 2.57146V23.1429Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Save",
  (strictLocalize) => ({
    color: Core.icon.default,
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Save",
      description: {
        text: "Message for screen readers when only the Save icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
